/**
 * AI-driven navigation contract - the generic mechanism for the conversational
 * copilot to suggest opening a page.
 *
 * Flow: a skill/tool (propose_navigation) emits an AiStructuredPayload whose
 * action carries a NavigationActionPayload on the existing actionType 'open'
 * (page-local 'open' actions branch on actionId and never use this shape - the
 * __kind discriminant disambiguates). The CLIENT maps NavigationTarget → SPA
 * route (resolveNavigationTarget in apps/web) and applies ChatMode semantics:
 *   ask   → render an "Open …" button; the user clicks to navigate.
 *   agent → auto-navigate the moment the live payload event arrives.
 *   auto  → auto-navigate only when the AI set autoNavigate (unambiguous intent).
 *
 * Extending to new pages = add a NavigationTarget variant + one client route
 * case + the tool's targetKind enum entry. The server never knows SPA routes.
 */
export const NAVIGATION_PAYLOAD_KIND = 'navigation';
export function isNavigationActionPayload(value) {
    if (!value || typeof value !== 'object')
        return false;
    const rec = value;
    if (rec.__kind !== NAVIGATION_PAYLOAD_KIND)
        return false;
    const target = rec.target;
    return !!target && typeof target === 'object' && typeof target.kind === 'string';
}
//# sourceMappingURL=ai-navigation.js.map